import { useEffect } from 'react';
import type { Form } from '../interfaces/form.interface';

export const usePageMetadata = (configuration?: Form) => {
  useEffect(() => {
    if (!configuration) return;

    // Actualizar el título de la página
    const title = configuration.theme?.content?.titles.main || 
      configuration.theme?.visual?.header?.title || 
      'Formulario de Inscripción';
    document.title = title;

    // Actualizar el favicon
    const icon = configuration.theme?.visual?.loader?.favicon || '/favicon.png';
    
    // Buscar el favicon existente o crear uno nuevo
    let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    
    favicon.href = icon;

    // También actualizar apple-touch-icon si existe
    let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
    
    if (!appleTouchIcon) {
      appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      document.head.appendChild(appleTouchIcon);
    }
    
    appleTouchIcon.href = icon;

  }, [configuration]);
}; 